<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ action }}</h4>

    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="hide()"></my-global-icon>
  </div>

  <div class="modal-body">
    <form novalidate [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-group">
        <label i18n for="hosts">1 host (without "http://") per line</label>

        <textarea
          [placeholder]="placeholder" formControlName="hosts" type="text" id="hosts" name="hosts"
          class="form-control" [ngClass]="{ 'input-error': formErrors['hosts'] }" ngbAutofocus
        ></textarea>

        <div *ngIf="formErrors.hosts" class="form-error">
          {{ formErrors.hosts }}

          <div *ngIf="form.controls['hosts'].errors.validHosts">
            {{ form.controls['hosts'].errors.validHosts.value }}
          </div>
        </div>
      </div>

      <ng-content select="warning"></ng-content>

      <div class="form-group inputs">
        <input
          type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
          (click)="hide()" (key.enter)="hide()"
        >

        <input type="submit" [value]="action" class="peertube-button orange-button" [disabled]="!form.valid" />
      </div>
    </form>
  </div>

</ng-template>
